import { createAction } from 'typesafe-actions';
import {
  NoteCreatePayload,
  NoteCreateResponse,
  NoteEntityResponse,
  NoteListResponse,
} from 'types/dto';

export enum NoteAction {
  Clear = 'NOTE_CLEAR',
  CreateRequest = 'NOTE_CREATE_REQUEST',
  CreateResponse = 'NOTE_CREATE_RESPONSE',
  Error = 'NOTE_ERROR',
  ListRequest = 'NOTE_LIST_REQUEST',
  ListResponse = 'NOTE_LIST_RESPONSE',
  Request = 'NOTE_REQUEST',
  Response = 'NOTE_RESPONSE',
}

export const noteClear = createAction(NoteAction.Clear)();
export const noteCreateRequest = createAction(NoteAction.CreateRequest)<NoteCreatePayload>();
export const noteCreateResponse = createAction(NoteAction.CreateResponse)<NoteCreateResponse>();
export const noteError = createAction(NoteAction.Error)<Error>();
export const noteListRequest = createAction(NoteAction.ListRequest)<string>();
export const noteListResponse = createAction(NoteAction.ListResponse)<NoteListResponse>();
export const noteRequest = createAction(NoteAction.Request)<string>();
export const noteResponse = createAction(NoteAction.Response)<NoteEntityResponse>();
